import React from 'react';
import { motion } from 'framer-motion';
export function UrgencyBar() {
  return <div className="sticky top-0 z-50 bg-[#1C1C1C] border-b border-[#C9A96E]/20" data-id="element-155">
      <div className="max-w-7xl mx-auto px-4 py-2.5 flex items-center justify-center gap-2" data-id="element-156">
        <motion.span animate={{
        scale: [1, 1.2, 1]
      }} transition={{
        duration: 1.5,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="text-[#C9A96E]" data-id="element-157">
          ⚠️
        </motion.span>
        <p className="text-xs sm:text-sm text-white/90 uppercase tracking-wider font-medium" data-id="element-158">
          Oferta de Lanzamiento:{' '}
          <span className="text-[#C9A96E] font-bold" data-id="element-159">50% de DESCUENTO</span>{' '}
          solo por las próximas 24 horas
        </p>
      </div>
    </div>;
}